<template>
  <div>
    <v-card>
      <v-container grid-list-lg>
        <v-layout class="ma-2" align-center="align-center" justify-center row wrap>
          <div class="text-center">
            <h1 class="display-3 font-weight-bold">Welcome</h1>
            <h1 class="body-1 font-weight-thin">You are all set.</h1>
          </div>
        </v-layout>
        <v-layout class="mt-3" column v-if="feature.length !== 0">
          <h1 class="display-1">Feature Change</h1>
          <v-container>
            <v-layout row wrap v-for="row in feature">
              <div>{{ row.feature }}</div>
              <v-spacer> </v-spacer>
              <div>{{ row.price | currency }}</div>
            </v-layout>
          </v-container>
        </v-layout>
        <v-layout class="mt-3" column v-if="order.length !== 0">
          <h1 class="display-1">Cart</h1>
          <v-container>
            <v-layout row wrap v-for="row in order">
              <div>{{ row.order }}</div>
              <v-spacer> </v-spacer>
              <div>{{ row.price | currency }}</div>
            </v-layout>
            <v-divider> </v-divider>
            <v-layout row wrap>
              <div class="font-weight-medium">Total</div>
              <v-spacer> </v-spacer>
              <div class="font-weight-medium">{{ total | currency }}</div>
            </v-layout>
          </v-container>
        </v-layout>
        <v-layout class="mt-5" align-center="align-center" justify-center row>
          <v-btn color="info" large dark="dark" @click="location">View Location</v-btn>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("location", ["resetLocation"]),
    location() {
      this.$router.push({ name: "location-dashboard" });
    }
  },
  created() {
    this.resetLocation();
  },
  computed: {
    ...mapGetters("location", ["order", "feature", "hardware", "hardwareTotal", "shipping"]),
    total() {
      let total = 0;
      this.order.map(row => {
        total = total + row.price;
      });
      return total;
    }
  }
};
</script>

<style scoped></style>
